import React from "react";
import Layout from "../../../components/layout";
import Seo from "../../../components/seo";
import { config } from "./data/config";
import ReferenceListSection from "../../../components/reference-list/ReferenceListSection";
import Banner from "./components/Banner";
import Footer from "./components/Footer";
import SelfTestSection from "./components/SelfTestSection";
import { useCmsCampaign } from "../../../cms/hooks/useCmsCampaign";
import "./index.scss";

const SelfTestCovid: React.FC = () => {
    const { campaign, layoutConfig, seoConfig } = useCmsCampaign('covid22');

    return (
        <Layout {...layoutConfig ?? config.layoutConfig}>
            <Seo {...seoConfig ?? config.seo} />
            <div className="self-test self-test_covid">
                <Banner />
                <SelfTestSection questions={config.questions} />
                <Footer />
                <ReferenceListSection references={campaign.data?.references ?? config.references} />
                <div className="support">
                    <p>
                        本網頁由輝瑞香港支持製作，內容只作參考之用，並非提供任何醫療意見或建議任何商品或服務，亦不可取代任何診斷或治療。有關您個人的治療情況，請咨詢您的醫生為作出準確的診斷，並提供適合的治療。藥物的成效和反應因使用者身體狀況及個別症狀有不同，詳情請向醫生或藥劑師查詢。
                    </p>
                </div>
            </div>
        </Layout>
    )
}

export default SelfTestCovid;
